export const state = {
  messageUnreadNum: 0
};
